import React, {useContext} from "react"
import {Panel, DataRow} from "../../PDFPrimitives"
import {PDFContext} from "../../BasePDF"

export const FinanceDealerPaymentInformationPDF = () => {
    const pdfData = useContext(PDFContext)
    if (!pdfData) return null

    return (
        <Panel title="Payment Information">
            <DataRow
                label="Total COD"
                value={pdfData.cash_due_on_delivery.toDollarFormat()}
            />
            <DataRow
                label="Monthly Payment"
                value={pdfData.monthly_payment.toDollarFormat()}
                variant="black"
            />
            <DataRow label="Term" value={String(pdfData.term)}/>
            <DataRow
                label="Days to 1st Payment"
                value={String(pdfData.days_to_first_payment)}
                isLast
            />
        </Panel>
    )
}
